var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 12.1,
    viewBox: "0 0 22 12.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-attachment",
    "data-name": "Icon material-attachment",
    d: "M3,16.55A6.047,6.047,0,0,1,9.05,10.5H20.6a4.4,4.4,0,0,1,0,8.8H11.25a2.75,2.75,0,0,1,0-5.5H19.5V16H11.151c-.6,0-.6,1.1,0,1.1H20.6a2.2,2.2,0,1,0,0-4.4H9.05a3.85,3.85,0,1,0,0,7.7H19.5v2.2H9.05A6.047,6.047,0,0,1,3,16.55Z",
    transform: "translate(-3 -10.5)",
    fill: "#3d7cc9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.65c2b05ef76c5d32b736360229ca4ec1.svg";
export { ForwardRef as ReactComponent };